module.exports = __webpack_public_path__ + "static/media/banner-product-2.1f84fab9.png";